import React, { useCallback, useEffect, useState } from "react";
// import { StyleSheet, Text, View } from 'react-native'
// import { getHeight, getWidth } from 'utils/helpers/relativeSizes'
// import getStyle from 'src/commonStyles/UniversalStyles'
// import { bigRewardsStatus } from 'utils/helpers/qaAutomationTestIdConstants'
// import { getCurrentTimestamp } from 'utils/ZupeeClock'
// import { NXTournament } from 'src/types/typesLudoNX'
// import { showTimerTextNX } from 'utils/TournamentNXUtils'
// import Cargo from 'utils/cargo'
import _isEmpty from "lodash/isEmpty";
// import { BigRewardsTopTimerBg } from 'assets/svgs'
// import { TIMER_EXPIRED_STRING } from 'screens/lobby/constants'
import _noop from "lodash/noop";
import _isNil from "lodash/isNil";
import { TIMER_EXPIRED_STRING } from "../../utils/helpers/tournamentConstants";
import cargo from "../../utils/cargo";
import { getCurrentTimestamp } from "../../utils/DateUtils";
import { showTimerTextNX } from "../../utils/helpers/TournamentNXUtils";
import clsx from "clsx";
import styles from "./styles.module.css";
import { WidgetItem } from "../../interfaces/TournamentsConfig";

interface INXTimer {
  tournament?: WidgetItem | undefined;
  timerText?: string;
  textStyles: object | undefined;
  containerStyles?: object | undefined;
  ignoreShowTimerFlag?: boolean;
  runWhenTimerReachesZero?: () => void;
}

const DELAY_IN_MILLIS = 1000;

const NxTimer = ({
  tournament,
  timerText,
  textStyles,
  containerStyles,
  ignoreShowTimerFlag,
  runWhenTimerReachesZero = _noop,
}: INXTimer) => {
  const [timer, setTimer] = useState<number | undefined>(undefined);
  const ltid = tournament?.ltid;
  const registrationStartTime = tournament?.registrationStartTime || 0;
  const registrationEndTime = tournament?.registrationEndTime || 0;
  const showCountDownTimer = showTimerTextNX(tournament, ignoreShowTimerFlag);

  const runSecondsTimer = useCallback(() => {
    if (!registrationStartTime || !registrationEndTime || !showCountDownTimer) {
      //Add log here
      return;
    }
    const currentTime = getCurrentTimestamp() as number;
    const timeToCompare =
      currentTime < registrationStartTime
        ? registrationStartTime
        : registrationEndTime;

    setTimer(Math.round(timeToCompare - getCurrentTimestamp()));
  }, [showCountDownTimer, registrationStartTime, registrationEndTime]);

  useEffect(() => {
    cargo.set(String(ltid), runSecondsTimer);
    return () => {
      cargo.purge(String(ltid));
    };
  }, [ltid, runSecondsTimer]);

  //Updating Timer text value
  let newTimerText = null;
  if (showCountDownTimer && timer) {
    let timerValue = "";
    if (timer / DELAY_IN_MILLIS <= 0) {
      timerValue = TIMER_EXPIRED_STRING;
    } else if (timer >= 24 * 60 * 60 * 1000) {
      // More than a day, show days and hours
      const days = Math.floor(timer / (24 * 60 * 60 * 1000));
      const hours = Math.floor(
        (timer % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
      );
      timerValue =
        days.toString() + "d " + hours.toString().padStart(2, "0") + "h";
    } else if (timer >= 60 * 60 * 1000) {
      // More than an hour, show hours and minutes
      const hours = Math.floor(timer / (60 * 60 * 1000));
      const mins = Math.floor((timer % (60 * 60 * 1000)) / (60 * 1000));
      timerValue =
        hours.toString().padStart(2, "0") +
        "h " +
        mins.toString().padStart(2, "0") +
        "m";
    } else {
      // Less than an hour, show minutes and seconds
      const mins = Math.floor(timer / (60 * 1000));
      const secs = Math.floor((timer % 60000) / 1000);
      timerValue =
        mins.toString().padStart(2, "0") +
        "m " +
        secs.toString().padStart(2, "0") +
        "s";
    }
    newTimerText = `${timerText} ${timerValue}`;
  }

  useEffect(() => {
    if (!_isNil(timer) && timer <= 0) {
      runWhenTimerReachesZero();
      cargo.purge(String(ltid));
    }
  }, [ltid, runWhenTimerReachesZero, timer]);

  if (_isEmpty(newTimerText)) {
    return null;
  }

  return (
    <div className={clsx([styles.topBg, containerStyles])}>
      {/* <BigRewardsTopTimerBg width={getWidth(124)} height={getHeight(18)} /> */}
      <div className={clsx([styles.timerPreText, textStyles])}>
        {newTimerText}
      </div>
    </div>
  );
};

export default NxTimer;

// const styles = StyleSheet.create({
//   topBg: {
//     position: 'absolute',
//     justifyContent: 'center',
//     alignItems: 'center',
//     top: 0,
//     left: 0,
//     right: 0,
//     zIndex: 1
//   },
//   timerPreText: {
//     position: 'absolute'
//   }
// })
